import { heroData } from '@/mocks/homeData';

export default function Hero() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-accent-50/40"></div>
      <div className="absolute top-0 right-0 w-[60%] h-full opacity-[0.07] pointer-events-none">
        <div className="absolute top-20 right-10 w-80 h-80 rounded-full bg-primary-500 blur-[120px]"></div>
        <div className="absolute bottom-20 right-40 w-64 h-64 rounded-full bg-accent-500 blur-[100px]"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 pt-24 pb-12 md:pb-16">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="flex flex-wrap justify-center lg:justify-start gap-2 mb-5">
              {heroData.tags.map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>

            <h1 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
              {heroData.h1}
            </h1>

            <p className="text-base md:text-lg text-primary-600 font-medium mb-6">
              {heroData.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              {heroData.intro}
            </p>

            <div className="flex flex-wrap justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-500 mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row justify-center lg:justify-start gap-3">
              <button
                onClick={() => scrollTo('#media')}
                className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观看
              </button>
              <button
                onClick={() => scrollTo('#about')}
                className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-background-50 hover:bg-background-100 text-foreground-700 font-medium rounded-lg text-sm border border-background-300 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line text-lg"></i>
                了解更多
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden bg-background-200/50 aspect-[16/10]">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20digital%20streaming%20visual%20with%20abstract%20warm%20gradient%20background%20in%20coral%20and%20peach%20tones%2C%20geometric%20play%20button%20and%20film%20strip%20elements%20floating%20in%20layered%20composition%2C%20cinematic%20atmosphere%20with%20soft%20glowing%20accents%2C%20clean%20minimal%20design%20with%20depth%2C%20no%20text%2C%20professional%20media%20platform%20aesthetic%20with%20warm%20lighting&width=1200&height=750&seq=hero-visual-2026&orientation=landscape"
                alt="芭乐视频平台主视觉 - 高清视频在线观看"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/10 via-transparent to-accent-500/10 pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}